/**
 * @file: useOnNavigateBack.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { usePersistFn } from '@euler/utils/hooks';
import { useEffect } from 'react';
import { BackHandler, Platform } from 'react-native';

export const useOnNavigateBack = (handler: () => void) => {
  const goBack = usePersistFn(handler);
  useEffect(() => {
    if (Platform.OS === 'web') return;
    const listener = BackHandler.addEventListener('hardwareBackPress', () => {
      goBack();
      return false;
    });
    return () => listener.remove();
  }, [goBack]);
  return goBack;
};
